module.exports = __webpack_public_path__ + "static/media/payNowSuccessMsg.da34546c.png";